const sectionAmendment = {
  i: "1",
  ii: "2",
  iii: "3",
  ivv: "13",
  vi: "5",
  vii: "6",
  viii: "7",
  ix: "8",
  x: "9",
  xi: "10",
  xii: "11",
  xiii: "12",
  sectionI: 0,
  sectionII: 1,
  sectionIII: 2,
  sectionIVV: 3,
  sectionVI: 4,
  sectionVII: 5,
  sectionVIII: 6,
  sectionIX: 7,
  sectionX: 8,
  sectionXI: 9,
  sectionXII: 10,
  sectionXIII: 11
};
export default sectionAmendment;
